global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

$(function() {
	//Utility functions
	function getScreenSize() {
		const width =
			window.innerWidth ||
			document.documentElement.clientWidth ||
			document.body.clientWidth;
		const height =
			window.innerHeight ||
			document.documentElement.clientHeight ||
			document.body.clientHeight;
		return { width, height };
	}

	function disableTabHiddenElements() {
		// Select all elements with the visually-hidden class
		const visuallyHiddenElements = document.querySelectorAll(
			'.visually-hidden a'
		);

		// Loop through each element and add the tabindex attribute
		visuallyHiddenElements.forEach(element => {
			element.setAttribute('tabindex', '-1');
		});

		// Select all elements with the visually-hidden class
		const visibleElements = document.querySelectorAll('.carousel-item a');
		// Loop through each element and add the tabindex attribute
		visibleElements.forEach(element => {
			element.removeAttribute('tabindex');
		});
	}

	function progressBarHandler(carousel, progressBar, nextBtn, prevBtn) {
		var count = parseInt(carousel?.dataset.elementCount || '1') - 1;
		var current = parseInt(carousel?.dataset.elementCurrent || '0');
		if (count > 0) progressBar.style.width = (current / count) * 100 + '%';
		else if (count == 0) {
			progressBar.style.width = '100%';
		} else {
			progressBar.style.width = '0%';
		}

		const screenSize = getScreenSize();
		if (screenSize.width >= 1024) {
			if (current < count) {
				nextBtn.removeAttribute('aria-hidden');
				nextBtn.classList.remove('visually-hidden');
				nextBtn.disabled = false;
			} else {
				nextBtn.classList.add('visually-hidden');
				nextBtn.setAttribute('aria-hidden', true);
				nextBtn.disabled = true;
			}
			if (current > 0) {
				prevBtn.removeAttribute('aria-hidden');
				prevBtn.classList.remove('visually-hidden');
				prevBtn.disabled = false;
			} else {
				prevBtn.classList.add('visually-hidden');
				prevBtn.setAttribute('aria-hidden', true);
				prevBtn.disabled = true;
			}
		} else {
			if (!nextBtn.classList.contains('visually-hidden'))
				nextBtn.classList.add('visually-hidden');
			if (!prevBtn.classList.contains('visually-hidden'))
				prevBtn.classList.add('visually-hidden');
		}
	}

	function generateDesktopItems() {
		var mobileItems = document.getElementsByClassName(
			'js-item-responsive js-courses_carousel'
		);
		var desktopItems = document.getElementsByClassName(
			'carousel-inner js-courses_carousel'
		);

		var divItem = document.createElement('div');
		divItem.classList.add(
			'desktop-only',
			'visually-hidden',
			'courses_slide'
		);

		var rowItem = document.createElement('div');
		rowItem.classList.add('row', 'pl_courses-carousel-row');

		for (let i = 0; i < mobileItems.length; i++) {
			var elementCloned = mobileItems[i].cloneNode(true);
			elementCloned.classList.remove('col-12');
			elementCloned.classList.remove('js-item-responsive');
			elementCloned.classList.add('col-4');
			rowItem.appendChild(elementCloned);

			if ((i + 1) % 3 == 0 || i + 1 == mobileItems.length) {
				divItem.appendChild(rowItem.cloneNode(true));
				desktopItems[0].appendChild(divItem.cloneNode(true));

				divItem = document.createElement('div');
				divItem.classList.add(
					'desktop-only',
					'visually-hidden',
					'courses_slide'
				);

				rowItem = document.createElement('div');
				rowItem.classList.add('row', 'pl_courses-carousel-row');
			}
		}
	}

	function init_courses_carousel() {
		//Declare variables
		var carousel = document.getElementById('courses_carousel');
		const nextBtn = document.getElementById('slider-courses-next');
		const prevBtn = document.getElementById('slider-courses-prev');
		const progressBar = document.getElementById('courses-progressbar');
		var slidesM = document.getElementsByClassName(
			'mobile-only courses_slide'
		);
		if (carousel) {
			//Listener Events
			window.addEventListener('resize', function() {
				const screenSize = getScreenSize();
				carousel.dataset.elementCurrent = 0;
				var slidesD = document.getElementsByClassName(
					'desktop-only courses_slide'
				);
				if (screenSize.width < 1024) {
					carousel.dataset.elementCount = slidesM.length;
					if (!nextBtn.classList.contains('visually-hidden'))
						nextBtn.classList.add('visually-hidden');
					if (!prevBtn.classList.contains('visually-hidden'))
						prevBtn.classList.add('visually-hidden');
					for (let i = 0; i < slidesM.length; i++) {
						slidesM[i].classList.remove('active');
						if (!slidesM[i].classList.contains('carousel-item')) {
							slidesM[i].classList.add('carousel-item');
						}
						if (slidesM[i].classList.contains('visually-hidden')) {
							slidesM[i].classList.remove('visually-hidden');
						}
						if (
							i == 0 &&
							!slidesM[i].classList.contains('active')
						) {
							slidesM[i].classList.add('active');
						}
					}
					for (let i = 0; i < slidesD.length; i++) {
						slidesD[i].classList.remove('active');
						if (slidesD[i].classList.contains('carousel-item')) {
							slidesD[i].classList.remove('carousel-item');
						}
						if (!slidesD[i].classList.contains('visually-hidden')) {
							slidesD[i].classList.add('visually-hidden');
						}
						if (slidesD[i].classList.contains('active')) {
							slidesD[i].classList.remove('active');
						}
					}
				} else {
					carousel.dataset.elementCount = slidesD.length;
					if (nextBtn.classList.contains('visually-hidden'))
						nextBtn.classList.remove('visually-hidden');
					if (prevBtn.classList.contains('visually-hidden'))
						prevBtn.classList.remove('visually-hidden');
					for (let i = 0; i < slidesM.length; i++) {
						slidesM[i].classList.remove('active');
						if (slidesM[i].classList.contains('carousel-item')) {
							slidesM[i].classList.remove('carousel-item');
						}
						if (!slidesM[i].classList.contains('visually-hidden')) {
							slidesM[i].classList.add('visually-hidden');
							slidesM[i].setAttribute('varia-hidden', true);
						}
						if (slidesM[i].classList.contains('active')) {
							slidesM[i].classList.remove('active');
						}
					}
					for (let i = 0; i < slidesD.length; i++) {
						slidesD[i].classList.remove('active');
						if (!slidesD[i].classList.contains('carousel-item')) {
							slidesD[i].classList.add('carousel-item');
						}
						if (slidesD[i].classList.contains('visually-hidden')) {
							slidesD[i].classList.remove('visually-hidden');
						}
						if (
							i == 0 &&
							!slidesD[i].classList.contains('active')
						) {
							slidesD[i].classList.add('active');
						}
					}
				}
				progressBarHandler(carousel, progressBar, nextBtn, prevBtn);
				disableTabHiddenElements();
			});

			carousel.addEventListener('slide.bs.carousel', function(data) {
				carousel.dataset.elementCurrent = data.to;
				progressBarHandler(carousel, progressBar, nextBtn, prevBtn);
			});

			//Carousel initialization
			const screenSize = getScreenSize();
			carousel.dataset.elementCurrent = 0;

			if (screenSize.width < 1024) {
				carousel.dataset.elementCount = slidesM.length;
				generateDesktopItems();
				if (!nextBtn.classList.contains('visually-hidden'))
					nextBtn.classList.add('visually-hidden');
				if (!prevBtn.classList.contains('visually-hidden'))
					prevBtn.classList.add('visually-hidden');
				for (let i = 0; i < slidesM.length; i++) {
					if (!slidesM[i].classList.contains('carousel-item')) {
						slidesM[i].classList.add('carousel-item');
					}
					if (slidesM[i].classList.contains('visually-hidden')) {
						slidesM[i].classList.remove('visually-hidden');
					}
					if (i == 0 && !slidesM[i].classList.contains('active')) {
						slidesM[i].classList.add('active');
					}
				}
			} else {
				generateDesktopItems();
				if (nextBtn.classList.contains('visually-hidden'))
					nextBtn.classList.remove('visually-hidden');
				if (prevBtn.classList.contains('visually-hidden'))
					prevBtn.classList.remove('visually-hidden');

				var slidesD = document.getElementsByClassName(
					'desktop-only courses_slide'
				);
				carousel.dataset.elementCount = slidesD.length;
				for (let i = 0; i < slidesD.length; i++) {
					if (!slidesD[i].classList.contains('carousel-item')) {
						slidesD[i].classList.add('carousel-item');
					}
					if (slidesD[i].classList.contains('visually-hidden')) {
						slidesD[i].classList.remove('visually-hidden');
					}
					if (i == 0 && !slidesD[i].classList.contains('active')) {
						slidesD[i].classList.add('active');
					}
				}
			}
			progressBarHandler(carousel, progressBar, nextBtn, prevBtn);
		}

		disableTabHiddenElements();
	}

	init_courses_carousel();
});
